/*
 * @Author: zwcong
 * @Description: 题型
 * @Date: 2021-12-21 16:15:44
 * @LastEditTime: 2022-03-21 10:34:28
 * @FilePath: /teacher-h5/src/service/topic/index-url.js
 */
let baseUrl = ''
// const passportUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = ''
} else {
  baseUrl = 'https://jzx.aixuexi.com'
  // passportUrl = 'https://www.aixuexi.com'
}

export default {
  // 查询学生自我巩固作答详情
  consolidationTopicAnswer: (lessonId, studentUserId) => `${baseUrl}/teaching/api/topicAnswer/lessons/${lessonId}/consolidation/new/${studentUserId}`,
  // 班级下所有答题记录
  topicAnswer: `${baseUrl}/teaching/api/topicAnswer/lessons/new/answers`,
  // 学生个人错题本
  wrongTopicAnswer: (lessonId, studentUserId) => `${baseUrl}/teaching/api/topicAnswer/wrongTopic/${lessonId}/book/${studentUserId}`,
  // 历史答题记录
  historyTopicAnswer: `${baseUrl}/teaching/api/topicAnswer/topic/history`
}
